import { Reveal } from "@/components/site/Reveal";
import { MapPin, Phone, NavigationArrow } from "@phosphor-icons/react";
import { useContent } from "@/context/ContentContext";
import { trackEvent } from "@/lib/api";

export function Location() {
  const { content } = useContent();
  const d = content.doctor;
  const c = content.contact;
  const facts = [
    ["Doctor", d.name],
    ["Specialty", d.specialty],
    ["Institution", d.institution],
    ["Location", "Dehradun, Uttarakhand"],
  ];

  return (
    <section className="py-24 md:py-32 bg-[#F4F7FA] scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-stretch">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="label">Location & Discovery</span>
              <h2 className="font-display text-4xl sm:text-5xl tracking-tight leading-tight mt-4 text-[#0A192F]">Find the Clinic</h2>
            </Reveal>
            <Reveal delay={0.1} className="mt-8 grid grid-cols-2 gap-x-8 gap-y-6" data-testid="location-facts">
              {facts.map(([l, v]) => (
                <div key={l} className="border-b border-[#E6EBF0] pb-4">
                  <span className="label text-[0.55rem]">{l}</span>
                  <p className="mt-1 text-[#0B1B2B] font-medium leading-snug">{v}</p>
                </div>
              ))}
            </Reveal>
            <Reveal delay={0.2} className="mt-8 bg-[#F4F7FA] rounded-2xl p-6">
              <div className="flex items-start gap-3">
                <MapPin size={22} weight="bold" className="text-[#0D9488] mt-0.5" />
                <p className="text-[#4A5A6A] leading-relaxed">{c.address}</p>
              </div>
              <div className="mt-5 flex flex-wrap gap-3">
                <a
                  href="https://www.google.com/maps/search/?api=1&query=SGRR+Medical+College+and+Hospital+Dehradun"
                  target="_blank" rel="noopener noreferrer"
                  onClick={() => trackEvent("directions_clicked")}
                  data-testid="get-directions-btn"
                  className="btn-accent inline-flex items-center gap-2 rounded-full text-sm font-semibold px-5 py-3 transition-[transform,background-color] duration-300"
                >
                  <NavigationArrow size={16} weight="bold" /> Get Directions
                </a>
                <a
                  href={`tel:${c.phone.replace(/\s/g, "")}`}
                  onClick={() => trackEvent("phone_clicked")}
                  data-testid="location-phone-btn"
                  className="btn-outline inline-flex items-center gap-2 rounded-full text-sm px-5 py-3 transition-[transform,border-color,color] duration-300"
                >
                  <Phone size={16} weight="bold" /> {c.phone}
                </a>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.15} className="h-full">
              <div className="relative h-full min-h-[360px] rounded-3xl overflow-hidden border border-[#E2E8F0]">
                <iframe
                  title="Clinic location map"
                  src="https://www.google.com/maps?q=SGRR%20Medical%20College%20and%20Hospital%20Dehradun&output=embed"
                  className="w-full h-full min-h-[360px]"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  data-testid="map-embed"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
